
export default {
  // savePortal({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.get("/api/apps/chat/chats")
  //       .then((response) => {
  //         commit('UPDATE_CHATS', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_RECORD', userId)
      resolve()

    })
  },
  setPortalType({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_PORTAL_TYPE', data)
      resolve();
    })
  },

  setPortalPermission({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_PORTAL_PERMISSION', data)
      resolve();
    })
  },

  updatePortal({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_PORTAL', data)
      resolve();
    })
  },

  resetPortal({ commit }) {
    return new Promise((resolve, reject) => {
      commit('RESET_PORTAL')
      resolve();
    })
  },



}
